import { deepAssign } from './assign';

/**
 * GraphQL nodes are wrapped in an object with a 'node' property, e.g.:
 * { node: { prop1: 'val1', prop2: 'val2' } }
 * Use this to get the object with the properties you're interested in.
 * @param obj GraphQL node wrapper object
 * @returns A deep clone of the node with data
 */
export function extractNode<T = any> (obj: any): T {
	const clone = Object.create(null);
	deepAssign(clone, obj.node ? obj.node : obj);

	return clone as T;
}
